module.exports = __webpack_public_path__ + "img/23.f0b29326.jpg";